import { computed, type ComputedRef } from 'vue'
import { useTranslate } from "@zotlo-shared/composable/useTranslate";
import { getPackageInfo } from '@zotlo-shared/elements/common/payment/utils';

export function usePriceInfo(props: Record<string, any>): ComputedRef<string> {
  const { translate } = useTranslate();

  const packageInfo = computed(() => {
    return getPackageInfo(props.pageData?.selectedPackage, { isTrialUsed: props.pageData?.isTrialUsed, locale: props.locale });
  });

  const params = computed(() => {
    const { price = '', trialPrice = '' } = packageInfo.value?.prices || {};
    const { period = 0, trialPeriod = 0, periodType = '', trialPeriodType = '' } = packageInfo.value?.periods || {};

    return {
      price,
      trialPrice,
      period : period === 0 ? '' : translate(`generate.periodBase.${periodType}`, props.locale, { count: period }),
      trialPeriod: trialPeriod === 0 ? '' : translate(`generate.periodBase.${trialPeriodType}`, props.locale, { count: trialPeriod }),
    }
  });

  return computed(() => translate(`generate.legalDocInfoElement.priceInfo.${packageInfo.value?.state}`, props.locale, params.value));
}
